import { Box, Skeleton } from "@mui/material";
import { useEffect } from "react";
import { useStoreUser } from "../../store/user";

export const IndentificationClient = ({ numeroTicket, handleNext }) => {
  const identification = useStoreUser();

  useEffect(() => {
    identification.identification(numeroTicket);
  }, []);
  return (
    <>
      {identification?.userIdentification?.status === "error" ? (
        <p className="text-red-500">Ce numero ftth n'est pas identifié</p>
      ) : (
        ""
      )}
      {identification.loadingIdentification &&
      identification.userIdentification == null ? (
        <div className="bg-white p-3 rounded-lg">
          <div className="px-4 sm:px-0"></div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Nom et prenom du client
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Email
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Contact client
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Ville du client
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'identification
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'approbation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'activation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'activation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  <Skeleton width={45} />
                </dd>
              </div>
            </dl>
          </div>
        </div>
      ) : (
        <div className="p-3 rounded-lg">
          <div className="px-4 sm:px-0"></div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Nom et prenom du client
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.nomPrenoms ?? "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Email
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.abonnement?.client
                    ?.email ?? "--"}
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Contact client
                </dt>
                <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.abonnement?.client
                    ?.numero ?? "--"}
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Ville du client
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.abonnement?.domicile
                    ?.quartier?.commune?.designation ?? "--"}
                </dd>
              </div>
              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'identification
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.dateHIdentification
                    ? new Date(
                        identification?.userIdentification?.dateHIdentification,
                      ).toLocaleString()
                    : "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'approbation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.dateHApprobation
                    ? new Date(
                        identification?.userIdentification?.dateHApprobation,
                      ).toLocaleString()
                    : "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Date et heure d'activation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.dateHActivation
                    ? new Date(
                        identification?.userIdentification?.dateHActivation,
                      ).toLocaleString()
                    : "--"}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Status d'approbation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.approvalStatus}
                </dd>
              </div>

              <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-bold leading-6 text-gray-900">
                  Status d'activation
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {identification?.userIdentification?.registrationStatus}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      )}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={
              identification?.userIdentification !== null ? false : true
            }
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={
              identification?.userIdentification?.status !== "error"
                ? handleNext
                : () => {
                    window.history.back();
                  }
            }
          >
            {identification?.userIdentification?.status === "error"
              ? "Quitter"
              : "Poursuivre"}
          </button>
        </div>
      </div>
    </>
  );
};
